// removed by extract-text-webpack-plugin
module.exports = {"labelContainer":"FieldCurrencyInput__labelContainer__2eu0R","input":"FieldCurrencyInput__input__3H5Io","inputSuccess":"FieldCurrencyInput__inputSuccess__2A4VE","inputError":"FieldCurrencyInput__inputError__eYonz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FieldCurrencyInput/FieldCurrencyInput.css
// module id = 1789
// module chunks = 0